module.exports = require('./lib/browser/Parse.js');



//////////////////
// WEBPACK FOOTER
// ./~/parse/index.js
// module id = 280
// module chunks = 0